/**
 * Central funnel step identifiers.
 *
 * Use these constants instead of raw string literals (e.g. "address-input") to
 * avoid typos and keep step IDs adjustable from a single place. The values are
 * constrained to the ambient `FunnelStepId` union via `satisfies`.
 */
export const FUNNEL_STEP_IDS = {
    ADDRESS_INPUT: 'address-input',
    PRODUCT_SELECTION: 'product-selection',
    DETAILS_INPUT: 'details-input',
    SOLAR_CONFIGURATOR: 'solar-configurator',
} as const satisfies Record<string, FunnelStepId>;

/** Ordered list of funnel step IDs as they appear in the funnel. */
export const FUNNEL_STEP_ID_ORDER: FunnelStepId[] = [
    FUNNEL_STEP_IDS.ADDRESS_INPUT,
    FUNNEL_STEP_IDS.PRODUCT_SELECTION,
    FUNNEL_STEP_IDS.DETAILS_INPUT,
    FUNNEL_STEP_IDS.SOLAR_CONFIGURATOR,
];

/** Legacy step IDs kept only for localStorage migration. */
export const LEGACY_FUNNEL_STEP_IDS = {
    LAYOUT: 'layout',
} as const;
